import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { dateFormat } from "../../utils/dateManager";

const ViewNotfication = ({ selectedNotification, open, setOpen }) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: "rounded-2xl"
      }}
    >
      <DialogTitle className="flex items-center justify-between border-b border-stone-100 px-6 py-4 text-lg font-semibold text-zinc-900">
        <span>Notification Details</span>
        <button
          onClick={() => setOpen(false)}
          className="rounded-full p-2 text-zinc-500 transition hover:bg-stone-100 hover:text-zinc-700"
          aria-label="Close dialog"
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </DialogTitle>
      <DialogContent className="max-h-[60vh] overflow-y-auto p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wide mb-1">Title</label>
            <p className="text-zinc-900">{selectedNotification?.title}</p>
          </div>
          <div>
            <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wide mb-1">URL</label>
            <p className="text-zinc-900 break-all">{selectedNotification?.url}</p>
          </div>
          <div className="md:col-span-2">
            <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wide mb-1">Message</label>
            <p className="text-zinc-900 break-words">{selectedNotification?.message}</p>
          </div>
          <div>
            <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wide mb-1">Language</label>
            <p className="text-zinc-900">{selectedNotification?.language}</p>
          </div>
          <div>
            <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wide mb-1">Date Range</label>
            <p className="text-zinc-900">
              {dateFormat("" + selectedNotification?.dateFrom)} - {dateFormat("" + selectedNotification?.dateTo)}
            </p>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="flex justify-end gap-3 border-t border-stone-100 bg-stone-50 px-6 py-4">
        <button
          onClick={() => setOpen(false)}
          className="bg-zinc-900 text-white hover:bg-zinc-800 px-5 py-2 rounded-lg text-sm font-medium transition-colors"
        >
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewNotfication;
